import './assets/styles/fonts.css';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Catalog from './pages/Catalog/Catalog';
import CarDetail from './pages/CarDetail/CarDetail';
import ShowroomAppointment from './components/ShowroomAppointment/ShowroomAppointment';
import TestDriveAppointment from './components/TestDriveAppointment/TestDriveAppointment';
import ServiceAppointment from './components/ServiceAppointment/ServiceAppointment';
import GetOffer from './components/GetOfferAppointment/GetOffer';
import ShopParts from './pages/Shop/ShopParts';
import ShopAccessories from './pages/Shop/ShopAccessories';

// Магазин грузится отдельным чанком: основной сайт не тяжелеет
const ShopLayout = lazy(() => import('./pages/Shop/ShopLayout'));
const ShopCatalog = lazy(() => import('./pages/Shop/ShopCatalog'));
const ShopProduct = lazy(() => import('./pages/ShopProduct/ShopProduct'));
const ShopCart = lazy(() => import('./pages/ShopCart/ShopCart'));
const ShopCheckout = lazy(() => import('./pages/ShopCart/ShopCheckout'));

function App() {
  return (
    <Router>
      <div
        className="app-container"
        style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
      >
        <Header />

        <main style={{ flex: 1 }}>
          <Suspense fallback={<div style={{ minHeight: '60vh', background: '#050505' }} />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalog/new" element={<Catalog type="new" />} />
              <Route path="/catalog/used" element={<Catalog type="used" />} />
              <Route path="/catalog/:type/:id" element={<CarDetail />} />
              <Route path="/visit_showroom" element={<ShowroomAppointment />} />
              <Route path="/test-drive-appointment" element={<TestDriveAppointment />} />
              <Route path="/service-appointment" element={<ServiceAppointment />} />
              <Route path="/poluchit-predlozhenie" element={<GetOffer />} />

              {/* Интернет-магазин запчастей */}
              <Route path="/shop" element={<ShopLayout />}>
                <Route index element={<ShopParts />} />
                <Route path="accessories" element={<ShopAccessories />} />
                <Route path="product/:slug" element={<ShopProduct />} />
                <Route path="cart" element={<ShopCart />} />
                <Route path="checkout" element={<ShopCheckout />} />
                <Route path="*" element={<Navigate to="/shop" replace />} />
              </Route>
            </Routes>
          </Suspense>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
